import { createSelector } from 'reselect';

const getError = state => state.error;

export const getErrorMessage = createSelector(
    getError,
    error => error.errorMessage || ''
);